/** Tabs of the admin booking detail, selected through the `?tab=` search param. */
export type AdminDetailTab = "overview" | "payment" | "chat";

export const ADMIN_DETAIL_TAB_PARAM = "tab";

/** Search string that opens the admin booking detail on the given tab. */
export function adminDetailTabSearch(tab: Exclude<AdminDetailTab, "overview">): string {
  return `?${ADMIN_DETAIL_TAB_PARAM}=${tab}`;
}

/** Tab from the `?tab=` value; the chat tab only exists for handshake activities. */
export function parseAdminDetailTab(
  value: string | null,
  hasChat: boolean,
): AdminDetailTab {
  if (value === "payment") return "payment";
  if (value === "chat" && hasChat) return "chat";
  return "overview";
}
